module.exports = __webpack_public_path__ + "img/La Joconde dans La Depeche du Midi.42e96970.jpg";